import LinkFactory from '@kaidam/fc-shared/src/frontend/components/widgets/Link'
import routes from '../../router/routes'

import {
  AppRoute,
} from '@kaidam/fc-shared/src/types/frontend/router'

const Link = LinkFactory(routes as AppRoute[])
export default Link
